import { FC } from 'react';
import { BareSvg } from '@/lib/bareSvg';
import { useNavigationItems } from '@/hooks/useNavigationItems';
import { StanLink } from '@/components';
import { useMobileModalNavigation } from '../hooks';

interface MoreOptionsSectionProps {
    onClose: () => void;
}

export const MoreOptionsSection: FC<MoreOptionsSectionProps> = ({ onClose }) => {
    const { mobileSecondaryItems } = useNavigationItems();
    const { handleNavigation } = useMobileModalNavigation({ onClose });

    if (mobileSecondaryItems.length === 0) return null;

    return (
        <div>
            <h3 className='text-dark mb-6'>More Options</h3>
            <div className='flex flex-wrap justify-center gap-x-5 gap-y-8 sm:gap-8'>
                {mobileSecondaryItems.map(item => (
                    <StanLink
                        key={item.id}
                        to={item.route}
                        onClick={e => {
                            e.preventDefault();
                            handleNavigation(item.redirect, item.route);
                        }}
                        className='flex flex-col items-center gap-3'
                    >
                        <div className='bg-brand-subtle flex aspect-square size-22 items-center justify-center rounded-lg p-3'>
                            <BareSvg
                                SvgComponent={item.icon}
                                className='text-dark size-full'
                                removeFill={item.removeFill}
                            />
                        </div>
                        <span className='text-label-sm-bold text-dark'>{item.title}</span>
                    </StanLink>
                ))}
            </div>
        </div>
    );
};
